<template>
    
    <div id="mainBox2" class="p-4 min-h-[50px]" style="background-color: #080718ff">

        <div class="flex items-center mt-4" style="background-color: #080718ff">
            <span style="color: #ffffffff">{{ langObj['显示单位'] }}:</span>

            <a-select ref="select" v-model:value="listSelectFac" style="width: 120px; margin-left: 20px;"
                @change="getGroupListDetail" :dropdownMatchSelectWidth="false">
                <a-select-option v-for="(item, index) in factoryList" :key="index" :value="item._id">{{
                        getTranslation(item.factoryName)
                    }}</a-select-option>
                </a-select>

            <div class="mx-4">></div>

            <a-select ref="select" v-model:value="listSelectGroup" style="width: 120px;" @change="selectGroup">
                <a-select-option v-for="(item, index) in groupList2" :key="index" :value="item.sonID">{{ getTranslation(item.name) 
                    }}</a-select-option>
            </a-select>

            <div class="flex-1"></div>

            <!-- <a-input v-model:value="value" style="width: 150px" placeholder="Enter area name">
                <template #prefix>
                    <search-outlined style="color: #fff" />
                </template>
            </a-input> -->


        </div>

        <!-- Factory dashboard - areas -->
        <div v-if="selectModel === 1" class="w-full flex dashboard-layout dashboard-shell"
            style="background-color: #080718ff; color: #fff; min-height: 92vh;">
            <!-- Left side -->
            <div class="flex flex-col dashboard-col dashboard-col-left">
             <div class="flex flex-col mt-2 w-full rounded-lg factory-scope-card" style="background: #171325ff; padding: 4px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); border: none;">
                 <!-- Header -->
                 <div class="flex items-center justify-between ml-4 mt-4 mb-4">
                     <h3 style="font-size: 20px; font-weight: 400; color: #b1afafff; margin: 0;">{{ langObj['监测范围'] }}</h3>
                     <a-tooltip placement="topLeft">
                         <template #title>
                             <div style="background: #fff; padding: 8px; border-radius: 4px; font-size: 12px; color: #1a202c;">
                                 <div style="margin-bottom: 4px;">{{ langObj['监控设备数:用户所选组织下的监测设备数统计'] }}</div>
                                 <div style="margin-bottom: 4px;">{{ langObj['监控测点数:用户所选组织下的监测测点数统计'] }}</div>
                                 <div style="margin-bottom: 4px;">{{ langObj['运行设备数:用户所选组织下的监测设备中运行设备数统计'] }}</div>
                                 <div>{{ langObj['运行率:用户所选组织下的监测设备中运行设备数/监测设备总数'] }}</div>
                             </div>
                         </template>
                         <question-circle-outlined style="font-size: 16px; color: #10b981; cursor: pointer;" />
                     </a-tooltip>
                 </div>

                 <!-- Metrics Grid -->
                 <div class="grid grid-cols-1 gap-2">
                     <!-- Equipment Count Card -->
                     <div style="padding: 10px; border-radius: 8px; background: rgb(15,15,30); border: 1px solid #2a2a3a; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06); transition: all 0.2s ease;" 
                         class="metric-card hover:shadow-lg" 
                         @mouseenter="$event.currentTarget.style.boxShadow='0 4px 12px rgba(16, 185, 129, 0.15)'; $event.currentTarget.style.borderColor='#3a3a4a';" 
                         @mouseleave="$event.currentTarget.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.06)'; $event.currentTarget.style.borderColor='#2a2a3a';">
                         <div style="font-size: 12px; color: #b1b1b1; font-weight: 500; margin-bottom: 4px; letter-spacing: 0.5px;">{{ langObj['监控设备数'] }}</div>
                         <div class="flex items-end justify-between">
                             <div>
                                 <div style="font-size: 28px; font-weight: 700; color: #10b981; line-height: 1;">{{ machineList.length }}</div>
                                 <div style="font-size: 12px; color: #b1b1b1; margin-top: 4px;">{{ getLanguage("台", language) }}</div>
                             </div>
                             <img src="@/assets/Equipmentmanagement-removebg.png" style="width: 28px; opacity: 0.6;" />
                         </div>
                     </div>

                     <!-- Sensor Count Card -->
                     <div style="padding: 10px; border-radius: 8px; background: rgb(15,15,30); border: 1px solid #2a2a3a; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06); transition: all 0.2s ease;" 
                         class="metric-card hover:shadow-lg" 
                         @mouseenter="$event.currentTarget.style.boxShadow='0 4px 12px rgba(59, 130, 246, 0.15)'; $event.currentTarget.style.borderColor='#3a3a4a';" 
                         @mouseleave="$event.currentTarget.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.06)'; $event.currentTarget.style.borderColor='#2a2a3a';">
                         <div style="font-size: 12px; color: #b1b1b1; font-weight: 500; margin-bottom: 4px; letter-spacing: 0.5px;">{{ langObj['监控测点数'] }}</div>
                         <div class="flex items-end justify-between">
                             <div>
                                 <div style="font-size: 28px; font-weight: 700; color: #3b82f6; line-height: 1;">{{ sensorList.length }}</div>
                                 <div style="font-size: 12px; color: #b1b1b1; margin-top: 4px;">{{ getLanguage("个", language) }}</div>
                             </div>
                             <img src="@/assets/cliqueD1.png" style="width: 28px; opacity: 0.6;" />
                         </div>
                     </div>

                     <!-- Running Equipment Card -->
                     <div style="padding: 10px; margin-bottom: 8px; border-radius: 8px; background: rgb(15,15,30); border: 1px solid #2a2a3a; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06); transition: all 0.2s ease;" 
                         class="metric-card hover:shadow-lg" 
                         @mouseenter="$event.currentTarget.style.boxShadow='0 4px 12px rgba(168, 85, 247, 0.15)'; $event.currentTarget.style.borderColor='#3a3a4a';" 
                         @mouseleave="$event.currentTarget.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.06)'; $event.currentTarget.style.borderColor='#2a2a3a';">
                         <div style="font-size: 12px; color: #b1b1b1; font-weight: 500; margin-bottom: 4px; letter-spacing: 0.5px;">{{ langObj['运行设备数'] }}</div>
                         <div class="flex items-end justify-between">
                             <div>
                                 <div style="font-size: 28px; font-weight: 700; color: #a855f7; line-height: 1;">{{ getRunMachine(machineList).num }}</div>
                                 <div style="font-size: 11px; color: #b1b1b1; margin-top: 4px;">({{ getRunMachine(machineList).rate }}%)</div>
                             </div>
                             <img src="@/assets/cliqueD2.png" style="width: 28px; opacity: 0.6;" />
                         </div>
                     </div>
                 </div>
             </div>

                <div class="flex flex-col mt-6 w-full rounded-lg factory-operation-card" style="background: #171325ff; padding: 20px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); border: none; min-height: 300px;">
                    <!-- Header -->
                    <h3 class="ml-4 mt-4 mb-4" style="font-size: 20px; font-weight: 400; color: #b1afafff; margin: 0;">{{ langObj['全厂运行情况'] }}</h3>

                    <!-- Stats Grid -->
                    <div class="grid grid-cols-2 gap-6 mt-6">
                        <!-- System Runtime Card -->
                        <div style="padding: 16px; border-radius: 8px; background: linear-gradient(135deg, #fef3c7 0%, #fef9e7 100%); border: 1px solid #fde68a; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06); transition: all 0.2s ease; position: relative;" 
                            @mouseenter="$event.currentTarget.style.boxShadow='0 4px 12px rgba(217, 119, 6, 0.15)'" 
                            @mouseleave="$event.currentTarget.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.06)'">
                            <!-- Blinking Status Indicator -->
                            <div class="status-indicator" style="position: absolute; bottom: 8px; right: 8px; width: 12px; height: 12px; border-radius: 50%; background-color: #10b981; box-shadow: 0 0 8px rgba(16, 185, 129, 0.6);"></div>
                            
                            <div class="flex items-start justify-between">
                                <div>
                                    <div style="font-size: 12px; color: #92400e; font-weight: 500; margin-bottom: 8px; letter-spacing: 0.5px;">{{ langObj['系统持续服务运行'] }}</div>
                                    <div style="font-size: 24px; font-weight: 700; color: #d97706; line-height: 1.2;">
                                        <div>{{ Math.floor(totalTime / (24 * 365)) }} <span style="font-size: 12px;">years</span></div>
                                        <div>{{ Math.floor((totalTime % (24 * 365)) / 24) }} <span style="font-size: 12px;">days</span></div>
                                        <div>{{ totalTime % 24 }} <span style="font-size: 12px;">hours</span></div>
                                    </div>
                                </div>
                                <a-tooltip placement="topLeft">
                                    <template #title>
                                        <div style="background: #fff; padding: 8px; border-radius: 4px; font-size: 12px; color: #1a202c;">
                                            {{ langObj['显示该系统为工厂上线运行的时间'] }}
                                        </div>
                                    </template>
                                    <question-circle-outlined style="font-size: 16px; color: #d97706; cursor: pointer;" />
                                </a-tooltip>
                            </div>
                        </div>

                        <!-- Health Score Card -->
                        <div style="padding: 16px; border-radius: 8px; background: linear-gradient(135deg, #d1fae5 0%, #ecfdf5 100%); border: 1px solid #a7f3d0; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06); transition: all 0.2s ease;" 
                            @mouseenter="$event.currentTarget.style.boxShadow='0 4px 12px rgba(16, 185, 129, 0.15)'" 
                            @mouseleave="$event.currentTarget.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.06)'">
                            <div class="flex items-start justify-between">
                                <div>
                                    <div style="font-size: 12px; color: #065f46; font-weight: 500; margin-bottom: 8px; letter-spacing: 0.5px;">{{ langObj['全厂运行设备健康分数'] }}</div>
                                    <div style="font-size: 32px; font-weight: 700; color: #10b981; line-height: 1;">{{ weightedAverage }}<span style="font-size: 20px;">%</span></div>
                                    <div style="font-size: 12px; color: #059669; margin-top: 4px;">{{ langObj['运行中设备状态得分'] }}</div>
                                </div>
                                <a-tooltip placement="topLeft">
                                    <template #title>
                                        <div style="background: #fff; padding: 8px; border-radius: 4px; font-size: 12px; color: #1a202c;">
                                            {{ langObj['针对运行中的设备, 状态得分的加权平均数计算为全厂健康分数, 健康设备记100分, 可用设备记80分, 警戒设备记60分, 故障设备记30分'] }}
                                        </div>
                                    </template>
                                    <question-circle-outlined style="font-size: 16px; color: #4b5563; cursor: pointer;" />
                                </a-tooltip>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!--midlle-->
            <div class="flex flex-col dashboard-col dashboard-col-middle">


            <div class="flex-col mt-2 w-full rounded-xl factory-health-card" style=" color: #b1afafff; background-color: #171325ff">
                <div class="flex items-center ml-4 mt-4 mb-4">
                    <span style="font-size:20px">  {{ langObj['设备健康状态统计'] }}</span>
                </div>

                <div class="w-full">
                    <div class="w-full flex ">
                        <div class="flex-1"></div>
                        <div class="mr-5" v-if="isShowFac">
                            <a-select ref="select" v-model:value="conditionSelectFac" style="width: 120px" size="small"
                                @change="getConditionChartData" :dropdownMatchSelectWidth="false">
                                <a-select-option v-for="(item, index) in factoryList" :key="index" :value="item._id">{{
                                    item.factoryName
                                }}</a-select-option>
                            </a-select>
                        </div>
                    </div>

                    <div class="w-full flex items-center">
                        <div v-if="visibleChart1" style="width: 240px; height: 240px" id="chartA"></div>
                        <div class="ml-4">
                            <div class="flex items-center" @click="selectMachineCondition(1)">
                                <div style="width:14px; height:14px; background-color: #61c08f"></div>
                                <div class="ml-2"> {{ langObj['健康'] }}:</div>
                                <div>{{ conditionChartData[0].num }}{{getLanguage("台", language)}}</div>
                            </div>
                            <div class="flex items-center mt-3" @click="selectMachineCondition(2)">
                                <div style="width:14px; height:14px; background-color: #706a00ff"></div>
                                <div class="ml-2"> {{ langObj['可用'] }}:</div>
                                <div>{{ conditionChartData[1].num }}{{getLanguage("台", language)}}</div>
                            </div>
                            <div class="flex items-center mt-3" @click="selectMachineCondition(3)">
                                <div style="width:14px; height:14px; background-color: #cd5f3b"></div>
                                <div class="ml-2"> {{ langObj['警戒'] }}:</div>
                                <div>{{ conditionChartData[2].num }}{{getLanguage("台", language)}}</div>
                            </div>
                            <div class="flex items-center mt-3" @click="selectMachineCondition(4)">
                                <div style="width:14px; height:14px; background-color: #921e37"></div>
                                <div class="ml-2"> {{ langObj['故障'] }}:</div>
                                <div>{{ conditionChartData[3].num }}{{getLanguage("台", language)}}</div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            <div class="flex-col mt-6 w-full rounded-xl factory-alarm-record-card" style="  min-height:400px; color: #b1afafff; background-color: #171325ff">
                <div class="flex items-center ml-4 mt-4 mb-4">
                    <span style="font-size:20px">  {{ langObj['设备报警记录'] }}</span>
                </div>

                <div class="w-full flex items-center mt-7">
                    <div class="flex-1"></div>
                    <div @click="viewMore" class="flex items-center cursor-pointer" style="color: #ffffffe6;">
                        <span>{{ langObj['查看更多'] }}</span>
                        <right-outlined />
                    </div>
                </div>

                <div class="w-full ml-2 mr-2 mb-4 mt-1">
                    <div class="w-full flex items-center" style="background-color: #080718ff;">
                        <div class="table-info" style="opacity: 0.6">{{ langObj['设备名称'] }}</div>
                        <div class="table-info" style="opacity: 0.6">{{ langObj['报警类型'] }}</div>
                        <div class="table-info" style="opacity: 0.6">{{ langObj['严重程度'] }}</div>
                        <div class="table-info" style="opacity: 0.6">{{ langObj['报警时间'] }}</div>
                    </div>

                    <div class="w-full flex items-center" v-for="(item, index) in machineWarningData" :key="index"
                        :style="{ 'background-color': index % 2 == 0 ? '#616161ff' : '#080718ff' }">
                        <div class="table-info" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                            :title="getTranslation(item.machineName)">{{ getTranslation(item.machineName) }}</div>
                        <div class="table-info">{{  langObj[warningTypeList.find(p => p.value === item.type)?.label] }}</div>
                        <div class="table-info" :style="{ 'color': getMachineWarningName(item.condition)?.color }">{{
                                langObj[getMachineWarningName(item.condition)?.name]
                            }}</div>
                        <div class="table-info">{{ item.date }}</div>
                    </div>

                </div>
            </div>

        </div>

            <!-- Right side -->
            <div class="flex flex-col ml-3 factory-zone-col" style="width:700px"> 
           
                <div class="flex-col w-full rounded-xl factory-zone-card" style=" min-height:750px; color: #b1afafff; background-color: #171325ff">
                    <div class="flex items-center ml-4 mt-4 mb-4">
                        <span style="font-size:20px">  {{ langObj['区域清单'] }}</span>
                    </div>
        


                    <div class="w-full flex items-center flex-wrap ">
                        <div v-for="(item, index) in groupListData" @click="selectGroup2(item)" :key="index"
                            class="box2 mt-4 mr-4">
                            <div class="w-full flex items-center">
                                <div class="shu"></div>
                                <div class="size18 ml-2" :title="item.name"
                                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ getTranslation(item.name) }}
                                </div>
                            </div>

                            <div class="heng"></div>

                            <div class="content flex items-center w-full">
                                <div>
                                    <div class="w-full flex items-center" style="text-align: left;">
                                        <div style="width: 160px;">
                                            <div class="size14 opc8">{{ langObj['监测设备'] }}</div>
                                            <div class="size18" style="color: #06DEF5;">{{ item.machineNum }}{{getLanguage("台", language)}}</div>
                                        </div>
                                        <div style="width: 160px;">
                                            <div class="size14 opc8">{{ langObj['监测测点'] }}</div>
                                            <div class="size18" style="color: #06DEF5;">{{ item.sensorNum }}{{getLanguage("个", language)}}</div>
                                        </div>
                                    </div>

                                    <div class="w-full flex items-center" style="text-align: left;">
                                        <div style="width: 160px;">
                                            <div class="size14 opc8">{{ langObj['运行设备'] }}</div>
                                            <div class="size18" style="color: #5BFEB7;">{{ item.machineRun }}{{getLanguage("台", language)}}</div>
                                        </div>
                                        <div style="width: 160px;">
                                            <div class="size14 opc8">{{ langObj['运行率'] }}</div>
                                            <div class="size18" style="color: #5BFEB7;">{{ item.machineRate }}</div>
                                        </div>
                                    </div>

                                    <div class="w-full flex items-center" style="text-align: left;">
                                        <div style="width: 160px;">
                                            <div class="size14 opc8">{{ langObj['报警设备'] }}</div>
                                            <div class="size18" style="color: #B81212;">{{ item.warningMachineNum }}{{getLanguage("台", language)}}</div>
                                        </div>
                                        <div style="width: 160px;">
                                            <div class="size14 opc8">{{ langObj['未处理报警'] }}</div>
                                            <div class="size18" style="color: #DDD246;">{{ item.noHandleNum }}{{getLanguage("条", language)}}</div>
                                        </div>
                                    </div>
                                </div>

                                <img src="@/assets/factory-group.png">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Factory dashboard - devices -->
        <div v-if="selectModel === 2" class="w-full flex dashboard-layout-alt dashboard-shell"
            style="background-color: #080718ff; color: #fff; min-height: 92vh;">
            <!-- Left side - Equipment Diagnosis -->
        
            <div class="flex flex-col mt-2 dashboard-alt-left">
                <div class="flex-col w-full rounded-xl" style=" color: #b1afafff; background-color: #171325ff">
                    <div class="flex items-center ml-4 mt-4 mb-4">
                        <span style="font-size:20px">  {{ langObj['设备诊断'] }}</span>
                    </div>

                    <div class="w-full flex items-center mt-4 ml-4">
                        <div class = "flex-col w-full">
                            <div class="ml-2" style="border-radius: 50%; background-color: #1cc48b; width: 16px; height: 16px"></div>
                            <div class="ml-1">{{ getLanguage('健康') }}：{{ getLanguage('80分以上') }}</div>
                            <div class="ml-2" style="border-radius: 50%; background-color: #ddd246; width: 16px; height: 16px"></div>
                            <div class="ml-1">{{ getLanguage('可用') }}：{{ getLanguage('60~80分') }}</div>
                        </div>
                        <div class = "flex-col w-full">
                            <div class="ml-2" style="border-radius: 50%; background-color: #cb6a34; width: 16px; height: 16px"></div>
                            <div class="ml-1">{{ getLanguage('警戒') }}：{{ getLanguage('30~60分') }}</div>
                            <div class="ml-2" style="border-radius: 50%; background-color: #b81212; width: 16px; height: 16px"></div>
                            <div class="ml-1">{{ getLanguage('故障') }}：{{ getLanguage('30分以下') }}</div>
                        </div>
                    </div>

                    <div class="mt-4 mb-4 flex items-center zone-radar-row">
                        <div class="zone-radar-item">
                            <div v-if="visibleChart2" id="chart2A" class="zone-radar-chart"></div>
                            <div class="mt-4" style="text-align: center;">{{langObj['健康指标']}}</div>
                        </div>
                        <div class="zone-radar-item">
                            <div v-if="visibleChart2" id="chart2B" class="zone-radar-chart"></div>
                            <div class="mt-4" style="text-align: center;">{{langObj['振动指标']}}</div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Middle side - Equipment Photo & Alarm Records -->
            <div class="flex flex-col mt-2 dashboard-alt-middle">
                <div class="flex-col w-full rounded-xl" style=" color: #b1afafff; background-color: #171325ff">
                    <div class="flex items-center ml-4 mt-4 mb-4">
                        <span style="font-size:20px">  {{ langObj['设备照片'] }}</span>
                    </div>
                    <pictureListComponent :type="4" :picList="picListAll"></pictureListComponent>
                </div>

                <div class="flex-col w-full rounded-xl mt-6" style=" color: #b1afafff; background-color: #171325ff">
                    <div class="flex items-center ml-4 mt-4 mb-4">
                        <span style="font-size:20px">  {{ langObj['设备报警记录'] }}</span>
                    </div>
                    <div class="flex-1"></div>
                        <div @click="viewMore" class="flex items-center cursor-pointer ml-4 mb-1" style="color: #ffffffe6;">
                            <span>{{langObj['查看更多']}}</span>
                            <right-outlined />
                    </div>

                    <div class="w-full mb-4">
                        <div class="w-full flex items-center" style="background-color: #080718ff;">
                            <div class="table-info" style="opacity: 0.6">{{langObj['设备名称']}}</div>
                            <div class="table-info" style="opacity: 0.6">{{langObj['报警类型']}}</div>
                            <div class="table-info" style="opacity: 0.6">{{langObj['严重程度']}}</div>
                            <div class="table-info" style="opacity: 0.6">{{langObj['报警时间']}}</div>
                        </div>

                        <div class="w-full flex items-center" style="color: #fff" v-for="(item, index) in machineWarningData2" :key="index"
                            :style="{ 'background-color': index % 2 == 0 ? '#b1afafff' : '#080718ff' }">
                            <div class="table-info" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" 
                            :title="getTranslation(item.machineName)">{{ getTranslation(item.machineName) }}</div>
                            <div class="table-info">{{ getLanguage(warningTypeList.find(p => p.value === item.type)?.label) }}</div>
                            <div class="table-info" :style="{ 'color': getMachineWarningName(item.condition)?.color }">{{
                                getLanguage(getMachineWarningName(item.condition)?.name) }}</div>
                            <div class="table-info">{{ item.date }}</div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Right side - Equipment List -->
            <div class="dashboard-alt-right">
            
                <div class="flex-col w-full rounded-xl mt-2" style=" color: #b1afafff; background-color: #171325ff">
                    <div class="flex items-center ml-4 mt-2 mb-4">
                        <span style="font-size:20px">  {{ langObj['设备清单'] }}</span>
                    </div>
 

                    <a-select ref="select" v-model:value="showSearchModel.follow" style="min-width: 120px;"
                        @change="getMachineListShow" :placeholder="langObj['全部'] || '全部'">
                        <a-select-option :value="null">
                            <div class="flex items-center">
                                <img class="picIcon" src="@/assets/factory-machine-1.png" alt="">
                                <div class="ml-2">{{langObj['全部']}}</div>
                            </div>
                        </a-select-option>
                        <a-select-option :value="true">
                            <div class="flex items-center">
                                <img class="picIcon" src="@/assets/factory-machine-1.png" alt="">
                                <div class="ml-2">{{langObj['关注']}}</div>
                            </div>
                        </a-select-option>
                        <a-select-option :value="false">
                            <div class="flex items-center">
                                <img class="picIcon" src="@/assets/factory-machine-2.png" alt="">
                                <div class="ml-2">{{langObj['未关注']}}</div>
                            </div>
                        </a-select-option>
                    </a-select>

                    <a-select ref="select" v-model:value="showSearchModel.status" style="width: 200px; margin-left:10px;"
                        @change="getMachineListShow" :placeholder="langObj['运行状态'] || '运行状态'">
                        <a-select-option :value="null">{{langObj['运行状态']}}</a-select-option>
                        <a-select-option :value="1">{{langObj['运行']}}</a-select-option>
                        <a-select-option :value="2">{{langObj['停机']}}</a-select-option>
                    </a-select>

                    <a-select ref="select" v-model:value="showSearchModel.codnition" style="width: 200px; margin-left:10px;"
                        @change="getMachineListShow" :placeholder="langObj['健康状态'] || '健康状态'">
                        <a-select-option :value="null">{{langObj['健康状态']}}</a-select-option>
                        <a-select-option :value="1">{{langObj['健康']}}</a-select-option>
                        <a-select-option :value="2">{{langObj['可用']}}</a-select-option>
                        <a-select-option :value="3">{{langObj['警戒']}}</a-select-option>
                        <a-select-option :value="4">{{langObj['故障']}}</a-select-option>
                    </a-select>


                    <div class="w-ful mt-5 mb-6 box3">
                        <div class="w-full flex items-center">
                            <environment-outlined style="color: #06DEF5; font-size: 14px;" />
                            <div class="ml-2" style="font-size: 16px;">{{ getTranslation(groupInfo.name) }}</div>
                            <div class="ml-2" style="font-size: 12px;">({{langObj['设备总数']}}:{{ groupInfo.machineNum }}{{langObj['台']}} | {{langObj['运行数']}}:{{
                                groupInfo.machineRun }}{{langObj['台']}} | {{langObj['报警设备']}}:{{ groupInfo.warningMachineNum }}{{langObj['台']}})</div>
                            <div class="flex-1"></div>
                            <!-- <div style="font-size: 12px;">Collapse</div> -->
                        </div>

                        <div class="flex items-center flex-wrap mb-4">
                            <div @click="selectMachine(item)" v-for="(item, index) in machineListShowPage" :key="index"
                                :style="{ 'background': item.id === machine_id ? '#1d1a2d' : '#080718ff', 'border-color': item?.workStableStatus?.condition ? getMachineWarningName(item?.workStableStatus?.condition).color : '#171325ff' }"
                                class="box4 cursor-pointer mt-3 mr-3">
                                <div class="w-full flex items-center">
                                    <div class="shu"></div>
                                    <div class="size14 ml-2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; " :title="item.machineName">{{ getTranslation(item.machineName) }}</div>
                                    <div class="flex-1"></div>
                                    <img class="picIcon" @click="follow(item, false)" v-if="item.follow"
                                        src="@/assets/factory-machine-1.png" alt="">
                                    <img class="picIcon" @click="follow(item, true)" v-if="!item.follow"
                                        src="@/assets/factory-machine-2.png" alt="">
                                </div>

                                <div class="heng"></div>

                                <div class="w-full flex items-center" style="margin-top: 5px;">
                                    <div class="flex-1 flex" style="justify-content: center;">
                                        <img style="height: 72px;" :src="item.url" alt="">
                                    </div>

                                    <div style="margin-left: 15px;">
                                        <div class="flex items-center" v-if="item.workStatus && item.workStatus.wkStatus">
                                            <div class="line">
                                                <div class="line animation"></div>
                                            </div>
                                            <span class="text-gray-50 pl-2">{{langObj['运行']}}</span>
                                        </div>
                                        <div class="flex items-center" v-else>
                                            <div class="down">
                                                <div class="down animation"></div>
                                            </div>
                                            <span class="text-gray-50 pl-2">{{langObj['停机']}}</span>
                                        </div>

                                        <div class="flex items-center mt-2">
                                            <div class="line"
                                                :style="{ 'background-color': getMachineWarningName(item?.workStableStatus?.condition).color }">
                                                <div class="line animation"
                                                    :style="{ 'background-color': getMachineWarningName(item?.workStableStatus?.condition).color }">
                                                </div>
                                            </div>
                                            <span class="text-gray-50 pl-2">{{
                                                langObj[getMachineWarningName(item?.workStableStatus?.condition).name ]}}</span>
                                        </div>

                                        <!-- <div class="flex items-center">
                                        <div class="down">
                                        </div>
                                        <span class="text-gray-50 pl-2">停机</span>
                                    </div> -->
                                    </div>
                                </div>

                                <div class="w-full items-center flex" style="margin-top: 5px">
                                    <span v-if="machine_info?.workStatus?.onLine">{{langObj['累计运行']}}</span>
                                    <div class="ml-2" style="color: #03b503ff;" v-if="machine_info?.workStatus?.onLine">{{
                                        machine_info.workStatus.onLine }}{{langObj['小时']}}</div>
                                    <div class="flex-1"></div>
                                    <div style="max-width: 110px; overflow: hidden;white-space: nowrap; text-overflow: ellipsis;"
                                        :title="item.faultTitle">{{ langObj[item.faultTitle] || getLanguage(item.faultTitle) || item.faultTitle }}</div>
                                </div>

                                <div class="w-full items-center flex">
                                    <span>{{langObj['速度均方根']}}</span>
                                    <div class="ml-2" style="color: #03b503ff;">{{ Number(item.sz)?.toFixed(2) }}mm/s</div>
                                    <div class="flex-1"></div>
                                    <span>{{langObj['温度']}}</span>
                                    <div class="ml-2" style="color: #03b503ff;">{{ item.temp }}℃</div>
                                </div>




                            </div>
                        </div>

                        <div style="margin-top: 20px; padding-top: 12px; border-top: 1px solid #333;">
                            <a-pagination
                                v-model:current="searchPage.skip"
                                v-model:page-size="searchPage.take"
                                :page-size-options="pageSizeOptions"
                                :total="searchPage.total"
                                show-size-changer
                                @change="changePage"
                            >
                                <template #buildOptionText="props">
                                <span>{{ props.value }} records/page</span>
                                </template>
                            </a-pagination>
                        </div>
                    </div>
                </div>


            </div>

        </div>

    </div>
  


</template>

<script lang="ts" setup>
import { defineComponent, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import request from "../../common/request";
import { transformDate } from "../../common/tools";
import { v4 as uuidv4 } from "uuid";
import * as echarts from "echarts";
import pictureListComponent from "../components/picture-list.vue";
import { langList } from "../../common/lang";
import { getRealFactoryIdListById, getGroupListByFactory } from "../../common/tools";
import { getLanguage, getTranslation } from "@/common/translate"
const router = useRouter()
// Dashboard display for area or device view     1: area / 2: device
let selectModel = ref(1)

let factory_id = ''
let factoryList: any = ref([])
let isShowFac = ref(false)
let totalTime = ref(0)
let weightedAverage: any = ref(0)
let groupList: any = ref([])
let machineList: any = ref([])
let sensorList: any = ref([])
let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
     language.value = 'English'
    langObj.value = langList[language.value]
}
getLang()

let conditionSelectFac: any = ref('')
let conditionChartData: any = ref([      // Equipment health status statistics data
    { label: langObj.value['健康'], num: 0, color: '#61c08f' },
    { label: langObj.value['可用'], num: 0, color: '#706a00ff' },
    { label: langObj.value['警戒'], num: 0, color: '#cd5f3b' },
    { label: langObj.value['故障'], num: 0, color: '#921e37' },
])
let machineWarningData: any = ref([])

let listSelectFac: any = ref('')
let listSelectGroup: any = ref('')

let value = ref('')

let visibleChart1 = ref(true)
let visibleChart2 = ref(true)



onMounted(() => {
    getLang()
    init()
    window.addEventListener('resize', resizeZoneRadarCharts)
})

onUnmounted(() => {
    window.removeEventListener('resize', resizeZoneRadarCharts)
})

const resizeZoneRadarCharts = () => {
    const chartIds = ['chart2A', 'chart2B']
    chartIds.forEach((id) => {
        const dom = document.getElementById(id)
        if (!dom) return
        const chart = echarts.getInstanceByDom(dom as HTMLDivElement)
        if (chart) {
            chart.resize()
        }
    })
}

const init = () => {
    factory_id = localStorage.getItem('factory_id') || ''
    conditionSelectFac.value = factory_id
    listSelectFac.value = factory_id
    loadFactory()
}

// Get factory list
const loadFactory = async () => {
    let groupInfo = getGroupListByFactory()
    let groups: any = []
    factoryList.value = []
    const config = {
        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.get("/api/factories", config)
    if (result.data && result.data.length) {
        factoryList.value = result.data.filter((p: any) => p._id === factory_id || p.parentId === factory_id)
        if(factoryList.value?.length > 1) {
            isShowFac.value = true
        }

        // Get runtime
        totalTime.value = 0
        let facL = factoryList.value.filter((p: any) => p.parentId === factory_id)
        if (facL && facL.length) {
            let time: any = 0
            facL.map((d: any) => {
                let targetTime: any = new Date(d.createAt); // Assume the target time is 2023-07-16 12:00:00 UTC
                let currentTime: any = new Date(); // Current time
                let time2 = Math.floor(
                    (currentTime - targetTime) / (1000 * 60 * 60)
                );
                if (time2 > time) {
                    time = time2
                }
            })
            totalTime.value = time

        } else {
            let info = factoryList.value.find((p: any) => p._id === factory_id)
            let targetTime: any = new Date(info.createAt); // Assume the target time is 2023-07-16 12:00:00 UTC
            let currentTime: any = new Date(); // Current time
            totalTime.value = Math.floor(
                (currentTime - targetTime) / (1000 * 60 * 60)
            );
        }

        result.data.forEach((element: any) => {
            element.groups = element.groups.map((t: any) => ({
                ...t,
                Name: element.factoryName + "-" + t.name,
            }));
            // groupInfo
            let groupss = element.groups.filter((p:any) => groupInfo.find((g:any) => g.id === p.sonID))
            if(groupss?.length > 0) {
                groups = groups.concat(groupss);
            }
        });

        getMain(groups);
    }
}


// Get area list
const getMain = async (groups: any) => {
    const config = {
        params: {
            factoryIds: getRealFactoryIdListById(factory_id) 
        },
        headers: {
            requestId: uuidv4(),
        },
    };
    let result = await request.get("/api/external/machines/workstatus", config)

    weightedAverage.value = 0
    groupList.value = [];
    machineList.value = [];
    sensorList.value = [];

    if (result && result.data) {
        let faultResult = await request.post('/api/faultinfos', { FeatureType: '' })
        result.data.map((d: any) => {
            let sz = 100000000000
            let temp = 100000000000
            d.quota && d.quota.map((q: any) => {
                if (q.values && q.values.length) {
                    let szInfo = q.values.find((p: any) => p.type === '速度Z')
                    if (szInfo) {
                        if (szInfo.value <= sz) {
                            sz = szInfo.value
                        }
                    }
                    let tempInfo = q.values.find((p: any) => p.type === '温度')
                    if (tempInfo) {
                        if (tempInfo.value <= temp) {
                            temp = tempInfo.value
                        }
                    }
                }
            })

            d.temp = temp == 100000000000 ? 0.00 : temp?.toFixed(2)
            d.sz = sz == 100000000000 ? 0 : sz

            let faultTitle = '设备运行正常'
            if (d.workStableStatus && d.workStableStatus.scores && Object.values(d.workStableStatus.scores).length) {
                let score = 100
                let name = ''
                for (let i in d.workStableStatus.scores) {
                    let value = d.workStableStatus.scores[i]
                    if (value <= score) {
                        score = value
                        name = i
                    }
                }
                faultTitle = faultResult.data.find((p: any) => p.scoreName === name)?.faultName
            }
            d.faultTitle = faultTitle
        })



        let weightAll = 0
        let count = 0
        groups.forEach((item2: any) => {
            item2.machines = result.data.filter(
                (t2: any) => t2.groupId == item2.sonID
            );
            item2.machines.map((d: any) => {
                sensorList.value = sensorList.value.concat(d.sensors)
                if (!d.workStatus) {
                    d.workStatus = {
                        condition: 0,
                        wkStatus: 0
                    }
                }
                if (!d.workStableStatus) {
                    d.workStableStatus = {
                        condition: 0,
                        wkStatus: 0
                    }
                }

                if (d.workStableStatus.condition === 0) {
                    weightAll = weightAll + 100
                }
                if (d.workStableStatus.condition >= 1 && d.workStableStatus.condition <= 2) {
                    weightAll = weightAll + 80
                }
                if (d.workStableStatus.condition >= 3 && d.workStableStatus.condition <= 5) {
                    weightAll = weightAll + 60
                }
                if (d.workStableStatus.condition >= 6 && d.workStableStatus.condition <= 7) {
                    weightAll = weightAll + 30
                }
                count++
                
            })
            machineList.value = machineList.value.concat(item2.machines)
            groupList.value.push(item2)
        })
        weightedAverage.value = count ? (weightAll / count).toFixed(2) : 0
    }


    setTimeout(() => {
        getConditionChartData()
        getMachineWarningChartData()
        getGroupListDetail()
    }, 500);

}

// Get operating device count and operating rate
const getRunMachine = (ev: any) => {
    let num: any = 0
    let rate: any = 0
    if (ev && ev.length) {
        ev.map((d: any) => {
            if (d.workStatus.wkStatus) {
                num++
            }
        })
        rate = ((num / ev.length) * 100).toFixed(2)
    }

    return { num, rate }
}

// Get equipment health status statistics / equipment operating status statistics data
const getConditionChartData = () => {
    let n1 = 0, n2 = 0, n3 = 0, n4 = 0
    let facList = factoryList.value.filter((p: any) => p.parentId && p.parentId === conditionSelectFac.value)
    if (facList.length) {
        facList.map((f: any) => {
            f.groups && f.groups.map((g: any) => {
                g.machines && g.machines.map((m: any) => {
                    if (m.workStableStatus.condition === 0) {
                        n1++
                    }
                    if (m.workStableStatus.condition >= 1 && m.workStableStatus.condition <= 2) {
                        n2++
                    }
                    if (m.workStableStatus.condition >= 3 && m.workStableStatus.condition <= 5) {
                        n3++
                    }
                    if (m.workStableStatus.condition >= 6 && m.workStableStatus.condition <= 7) {
                        n4++
                    }
                })
            })
        })
    } else {
        let f = factoryList.value.find((p: any) => p._id === conditionSelectFac.value)
        f?.groups && f.groups.map((g: any) => {
            g.machines && g.machines.map((m: any) => {
                if (m.workStableStatus.condition === 0) {
                    n1++
                }
                if (m.workStableStatus.condition >= 1 && m.workStableStatus.condition <= 2) {
                    n2++
                }
                if (m.workStableStatus.condition >= 3 && m.workStableStatus.condition <= 5) {
                    n3++
                }
                if (m.workStableStatus.condition >= 6 && m.workStableStatus.condition <= 7) {
                    n4++
                }
            })
        })
    }


    conditionChartData.value = [
        { label: langObj.value['健康'], num: n1, color: '#61c08f' },
        { label: langObj.value['可用'], num: n2, color: '#706a00ff' },
        { label: langObj.value['警戒'], num: n3, color: '#cd5f3b' },
        { label: langObj.value['故障'], num: n4, color: '#921e37' },
    ]

    initConditionChart()
}

// Draw the equipment health status chart
const initConditionChart = () => {
    if (!document.getElementById("chartA")) return
    let myChart = echarts.init(document.getElementById("chartA") as HTMLDivElement);

    let DData = conditionChartData.value.map((t: any) => ({
        value: t.num,
        name: t.label
    }))
    const total = conditionChartData.value.reduce((sum: number, item: any) => sum + item.num, 0)

    let options = {
        tooltip: {
            show: true,
            trigger: "item",
            backgroundColor: "rgba(10, 14, 34, 0.95)",
            borderColor: "rgba(255, 255, 255, 0.15)",
            textStyle: { color: "#ffffff" },
            formatter: "{b}<br/>{c} ({d}%)",
        },
        graphic: [
            {
                type: "text",
                left: "center",
                top: "44%",
                style: {
                    text: langObj.value["总设备数"],
                    textAlign: "center",
                    fontSize: 12,
                    fill: "rgba(255, 255, 255, 0.7)",
                    fontWeight: 500,
                },
            },
            {
                type: "text",
                left: "center",
                top: "52%",
                style: {
                    text: String(total),
                    textAlign: "center",
                    fontSize: 28,
                    fill: "#ffffff",
                    fontWeight: 700,
                },
            },
        ],
        series: [
            {
                type: "pie",
                radius: ["58%", "87%"],
                center: ["50%", "50%"],
                silent: true,
                label: { show: false },
                data: [{ value: 1, itemStyle: { color: "rgba(255,255,255,0.10)" } }],
            },
            {
                name: "",
                type: "pie",
                radius: ["61%", "82%"],
                center: ["50%", "50%"],
                avoidLabelOverlap: true,
                padAngle: 1,
                minAngle: 3,
                itemStyle: {
                    borderColor: "transparent",
                    borderWidth: 0,
                    borderRadius: 1,
                },
                label: { show: false },
                emphasis: {
                    scale: true,
                    scaleSize: 4,
                },
                labelLine: { show: false },
                data: DData,
            },
        ],
        color: ['rgb(28, 196, 139)', 'rgb(206, 224, 8)', 'rgb(223, 87, 45)', 'rgb(162, 3, 53)']
    };

    myChart.setOption(options);
    myChart.off("mouseover");
    myChart.off("mouseout");
    myChart.on("mouseover", (params: any) => {
        if (!params?.name) return;
        options.graphic[0].style.text = params.name;
        options.graphic[1].style.text = String(params.value ?? 0);
        myChart.setOption(options);
    });
    myChart.on("mouseout", () => {
        options.graphic[0].style.text = langObj.value["总设备数"];
        options.graphic[1].style.text = String(total);
        myChart.setOption(options);
    });

}

// 获取设备报警记录
let warningTypeList = [
    { label: '智能诊断', value: 1 },
    { label: '门限报警', value: 4 },
]
const getMachineWarningChartData = async () => {
    machineWarningData.value = []
    let facList = factoryList.value.filter((p: any) => p.parentId && p.parentId === factory_id)
    let factoryIds = []
    if (facList && facList.length) {
        factoryIds = facList.map((p: any) => p._id)
    } else {
        factoryIds = [factory_id]
    }
    let config: any = {
        params: {
            skip: 1,
            take: 7,
            factoryIds,
            typeList: [1, 4]
        },

        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.get('/api/workflows', config)

    if (result && result.data) {
        machineWarningData.value = result.data.list
        machineWarningData.value.map((d: any) => {
            d.date = d.date.substring(5, 16)
        })
    }
}

// 获取严重程度名称颜色
const getMachineWarningName = (condition: any) => {
    let name = '健康'
    let color = '#61c08f'
    if (condition >= 1 && condition <= 2) {
        name = '可用'
        color = '#706a00ff'
    }
    if (condition >= 3 && condition <= 5) {
        name = '警戒'
        color = '#cd5f3b'
    }
    if (condition >= 6 && condition <= 7) {
        name = '故障'
        color = '#921e37'
    }

    return { name, color }
}

// 获取区域清单
let groupListData: any = ref([])
let groupList2: any = ref([{ name: langObj.value['全部区域'], sonID: '' }])
const getGroupListDetail = async () => {
    let facList = factoryList.value.filter((p: any) => p.parentId && p.parentId === listSelectFac.value)
    let factoryIds = []
    if (facList && facList.length) {
        factoryIds = facList.map((p: any) => p._id)
    } else {
        factoryIds = [listSelectFac.value]
    }
    groupList2.value = [{ name: langObj.value['全部区域'], sonID: '' }]
    //获取未处理事件
    let config: any = {
        params: {
            skip: 1,
            take: 1000000,
            factoryIds,
            typeList: [1],
            handleStatus: 1,
        },

        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.get('/api/workflows', config)
    let noHandeleList: any = []
    if (result && result.data && result.data.list) {
        noHandeleList = result.data.list
    }

    let groList: any = []
    factoryIds.map((facId: any) => {
        let facInfo = factoryList.value.find((p: any) => p._id === facId)
        let list1: any = []

        groupList2.value = groupList2.value.concat(facInfo.groups)
        list1 = facInfo.groups

        list1 && list1.map((g: any) => {
            let machineNum = 0
            let sensorNum = 0
            let machineRun = 0
            machineNum = machineNum + (g.machines ? g.machines.length : 0)

            g.machines && g.machines.map((m: any) => {
                sensorNum = sensorNum + (m.sensors ? m.sensors.length : 0)
                if (m.workStatus && m.workStatus.wkStatus) {
                    machineRun++
                }
            })

            g.machineNum = machineNum
            g.sensorNum = sensorNum
            g.machineRun = machineRun
            g.machineRate = machineNum ? (((machineRun / machineNum) * 100).toFixed(0) + '%') : '0%'


            let noHandleNum = 0
            let warningMachineNum = 0
            g.machines && g.machines.map((m: any) => {
                let noL = noHandeleList.filter((p: any) => p.machineId === m.id)
                if (noL && noL.length) {
                    noHandleNum = noHandleNum + noL.length
                    let conditionL = [
                        { value: 0, list: [0] },
                        { value: 1, list: [1, 2] },
                        { value: 2, list: [3, 4, 5] },
                        { value: 3, list: [6, 7] },
                    ]

                    if (m.workStableStatus && m.workStableStatus.condition) {
                        let c1: any = conditionL.find((p: any) => p.list.includes(m.workStableStatus.condition))?.value
                        let c2: any = conditionL.find((p: any) => p.list.includes(noL[0].condition))?.value
                        if (c1 >= c2) {
                            warningMachineNum++
                        }
                    }
                }
            })
            g.noHandleNum = noHandleNum
            g.warningMachineNum = warningMachineNum
        })
        groList = groList.concat(list1)
    })

    let groupInfo = getGroupListByFactory()
    let groLists = groList.filter((p:any) => groupInfo.find((g:any) => g.id === p.sonID))
    groupListData.value = groLists
}

// 选择区域
let groupInfo: any = ref({ machines: [] })
let machineListShow: any = ref([])
let showSearchModel: any = ref({
    follow: null,
    codnition: null,
    status: null
})
let machine_id = ref('')
const selectGroup = async (ev: any) => {
    if (listSelectGroup.value) {
        selectModel.value = 2
        visibleChart2.value = false
        visibleChart2.value = true
        groupInfo.value = groupListData.value.find((p: any) => p.sonID === listSelectGroup.value)

        if (groupInfo.value.machines?.length > 0) {
            getSensorList(groupInfo.value.machines[0])
            getRandarData(groupInfo.value.machines[0])
            getMachineWarningData(groupInfo.value.machines[0])
            machine_id.value = groupInfo.value.machines[0].id
        }

        getMachineListShow()
    } else {
        selectModel.value = 1
        visibleChart1.value = false
        visibleChart1.value = true
        setTimeout(() => {
            getConditionChartData()
        }, 500);
    }

}

const selectGroup2 = (ev: any) => {
    listSelectGroup.value = ev.sonID
    selectGroup(listSelectGroup.value)
}

//筛选显示设备
const getMachineListShow = () => {
    let list = JSON.parse(JSON.stringify(groupInfo.value.machines))

    if (showSearchModel.value.follow == true) {
        list = list.filter((p: any) => p.follow === showSearchModel.value.follow)
    }
    if(showSearchModel.value.follow == false) {
        list = list.filter((p: any) => !p.follow)
    }


    if (showSearchModel.value.status) {
        if (showSearchModel.value.status === 1) {
            list = list.filter((p: any) => p.workStatus && p.workStatus.wkStatus === 1)
        }
        if (showSearchModel.value.status === 2) {
            list = list.filter((p: any) => !p.workStatus || p.workStatus.wkStatus === 0)
        }
    }
    if (showSearchModel.value.codnition) {
        if (showSearchModel.value.codnition === 1) {
            list = list.filter((p: any) => !p.workStableStatus || p.workStableStatus.condition === 0)
        }
        if (showSearchModel.value.codnition === 2) {
            list = list.filter((p: any) => p.workStableStatus && p.workStableStatus.condition >= 1 && p.workStableStatus.condition <= 2)
        }
        if (showSearchModel.value.codnition === 3) {
            list = list.filter((p: any) => p.workStableStatus && p.workStableStatus.condition >= 3 && p.workStableStatus.condition <= 5)
        }
        if (showSearchModel.value.codnition === 4) {
            list = list.filter((p: any) => p.workStableStatus && p.workStableStatus.condition >= 6 && p.workStableStatus.condition <= 7)
        }
    }

    list.map((p: any) => {
        if (p.pictures?.length > 0) {
            p.url = p.pictures[0].url;
        }
    });

    machineListShow.value = list
    machineListShow.value.sort((a:any, b:any) => {return a.sort-b.sort})

    searchPage.value.total = list.length
    searchPage.value.skip = 1
    changePage(searchPage.value.skip, searchPage.value.take)
}

// 设备列表分页'
let machineListShowPage:any = ref([])
let pageSizeOptions = ref<string[]>(['5', '10', '20']);
let searchPage = ref({
    skip: 1,
    take: 10,
    total: 0
})

const changePage = (current:any, pageSize:any) => {
    machineListShowPage.value = machineListShow.value.slice((current-1)*pageSize, current*pageSize)
}


// 获取雷达图数据
const getRandarData = async (machine: any) => {
    let faultnamesSearch = {
        params: { machineId: machine.id },
        headers: {
            requestId: uuidv4(),
        },
    }
    let result = await request.get('/api/machines/faultnames', faultnamesSearch)
    let faultName = result.data.faultNames
    let faultNameII = result.data.faultNameExpects

    let Slist: any = []
    let Tlist: any = []

    if (machine.workStableStatus && machine.workStableStatus.scores) {
        for (let index in machine.workStableStatus.scores) {
            const item = machine.workStableStatus.scores[index];
            if (index.includes('S')) {
                Slist.push({
                    quota: index,
                    score: item,
                    text: langObj.value[faultName.find((p: any) => p.column === index)?.title] || faultName.find((p: any) => p.column === index)?.title
                })
            }

            if (index.includes('T')) {
                Tlist.push({
                    quota: index,
                    score: item,
                    text: langObj.value[faultNameII.find((p: any) => p.column === index)?.title] || faultNameII.find((p: any) => p.column === index)?.title,
                })
            }
        }
    }

    setTimeout(() => {
        initRandarChart(Tlist, 'chart2A')
        initRandarChart(Slist, 'chart2B')
    }, 500);
}

// 雷达图绘制
const initRandarChart = (dataList: any, id: any) => {
    const ec = echarts as any;
    const target = document.getElementById(id)
    if (!target) return
    let myChart = ec.getInstanceByDom(target) || ec.init(target);
    myChart.clear()

    if (!dataList.length) return

    let data: any = []
    let error: any = []
    let indicator: any = []
    dataList.map((d: any) => {
        data.push(d.score)
        error.push(60)
        let color = ''
        if (d.score >= 0 && d.score < 60) {
            color = '#CD5F3B'
        }
        if (d.score >= 60 && d.score < 80) {
            color = '#706a00ff'
        }
        if (d.score >= 80 && d.score <= 100) {
            color = '#fff'
        }
        let name = ''
        if((language.value == "Chinese" || language.value == "Chinese_ft") && d.text) {
        if (d.text.length > 8) {
            name = (d.text.substring(0, 4) + '\n' + d.text.substring(4, 8) + '\n' + d.text.substring(8, d.text.length))
        } else if (d.text.length > 4 && d.text.length <= 8) {
            name = d.text.substring(0, 4) + '\n' + d.text.substring(4, d.text.length)
        } else {
            name = d.text
        }
        } 

        if(language.value == "English" && d.text) {
        let list1 = d.text.split(' ')

        let str:any = ''
        let num = 0
        let sy = ''
        list1.map((n:any, i:any) => {
            if(i==0) {
            if(n.length <= 10) {
                num = n.length
                str = n
            } else {
                num = 10
                let a1 = n.substring(0,10)
                sy = n.slice(10)
                str = a1
            }
            } else {

            if(sy) {
                str = str + '\n' ;
                let n2 = sy.length + n.length
                if(n2 <= 10) {
                num = n2
                str = str + sy + ' ' + n
                sy = ''
                } else {
                num = 10
                str = str + sy
                let n2 = 10 - sy.length >=0 ? 10 - sy.length : 0

                let a1 = n.substring(0,n2)
                sy = n.slice(10)
                str = str + a1
                }
            } else {
                if(num + n.length <= 10) {
                str = str + ' ' + n
                num = num + n.length
                } else {
                str = str + '\n'  + n
                num = n.length
                }
            }
            }
        })
        name = str
        }

        indicator.push({
            color,
            max: 100,
            text:name
        })
    })

    const option = {
        title: {
            text: ''
        },
        tooltip: {
            position: { right: '-50px' }
        },
        radar: [
            {
                indicator: indicator,
                center: ['50%', '50%'],
                radius: 50,
                startAngle: 90,
                splitNumber: 5,
                axisName: {
                    formatter: '{value}',
                    fontSize: 10,
                },
                name: {
                    formatter: '{value}',
                    textStyle: {
                        color: 'rgba(46, 214, 157, 1)',
                        fontSize: 11
                    }
                },
                splitArea: {
                    areaStyle: {
                        color: [
                            '#605969',
                            '#453A47',
                        ]
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: [
                            'rgb(241,243,250)'
                        ],
                        width: 0
                    }
                }
            }
        ],
        series: [
            {
                name: '当前值',
                type: 'radar',
                emphasis: {
                    lineStyle: {
                        width: 4
                    }
                },
                symbolSize: 2, // 拐点的大小
                data: [
                    {
                        value: data,
                        lineStyle: {
                            width: 1,
                            color: 'rgba(247,220,225,0.1)',
                            normal: {
                                type: 'dotted'
                            }
                        },
                        itemStyle: {
                            color: '#FF4E13',
                            borderWidth: 5
                        },
                        areaStyle: {
                            color: '#F7DCE1'
                        }
                    }
                ]
            },
            {
                name: '预警值',
                type: 'radar',
                emphasis: {
                    lineStyle: {
                        width: 1
                    }
                },
                symbolSize: 2, // 拐点的大小
                data: [
                    {
                        value: error,
                        name: '',
                        lineStyle: {
                            width: 2,
                            color: 'rgba(255, 25, 59, 0.2)'
                        },
                        itemStyle: {
                            color: 'rgba(255, 25, 59, 0.2)',
                            borderWidth: 0
                        }
                    }
                ]
            }
        ]
    }

    option && myChart.setOption(option)
    option && myChart.setOption(option);
    myChart.resize()
}

// 获取设备报警记录
let machineWarningData2: any = ref([])
const getMachineWarningData = async (machine: any) => {
    let config: any = {
        params: {
            skip: 1,
            take: 7,
            machineId: machine.id,
            typeList: [1, 4]
        },

        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.get('/api/workflows', config)
    if (result && result.data) {
        machineWarningData2.value = result.data.list
        machineWarningData2.value.map((d: any) => {
            d.date = d.date.substring(5, 16)
        })
    }
}


//选择设备
let picList: any = ref([])
let picListAll: any = ref([])
let machine_info: any = ref({})
const selectMachine = (ev: any) => {
    machine_info.value = ev
    machine_id.value = ev.id
    getSensorList(ev)
    getRandarData(ev)
    getMachineWarningData(ev)
}

const getSensorList = async (machine: any) => {
    picList.value = [];
    if (machine.pictures?.length > 0) {
        picList.value.push({ name: machine.machineName, url: machine.pictures[0].url });
    }

    let config: any = {
        params: {
            machineId: machine.id,
        },
        headers: {
            requestId: uuidv4(),
        },
    };
    let result = await request.get("/api/sensors", config);

    if (result && result.status === 200) {
        result.data.map((d: any) => {
            if (d.pictures) {
                d.pictures.map((p: any) => {
                    picList.value.push({
                        name: d.sensorPlace,
                        url: p.url
                    })
                })

            }
        })
    }

    picListAll.value = picList.value

};



//关注、取关
const follow = async (ev: any, value: any) => {
    
    ev.follow = value
    // return
    let form = {
        machineId: ev.id,
        follow: value
    }

    let result = await request.post('/api/machines/follow', form)
    if(result?.data) {
        let info = groupInfo.value.machines.find((p:any) => p.id === ev.id)
        if(info) {
            info.follow = value
        }
    }
}


// 查看更多
const viewMore = () => {
    router.push('/warning-manage/warning-list')
}

</script>

<style lang="less" scoped>
.enW{
    width: 300px;
}
/deep/ .ant-select-single.ant-select-sm:not(.ant-select-customize-input) .ant-select-selector {
    background-color: #171325ff;
    border: 1px solid #3a3a3aff;
    color: #fff;
}

/deep/ .ant-select-arrow {
    color: #fff
}

/deep/ .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: #171325ff;
    border: 1px solid #3a3a3aff;
    color: #fff;
}

/deep/ .ant-input-affix-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 11px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 1.5715;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: all 0.3s;
    display: inline-flex;
}

/deep/ .ant-input {
    background-color: #171325ff;
    color: #fff;
}


.title {
    width: 350px;
    height: 38px;
    font-size: 20px;
    color: #06DEF5;
    background: linear-gradient(90deg, #1c39c88f 0%, #00148d00 100%);

    .shu {
        width: 2px;
        height: 20px;
        background-color: #fff;
    }
}

.box1 {
    width: 230px;
    height: 76px;
    position: relative;

    .content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding-top: 10px;
        color: #06DEF5;
    }
}

.table-info {
    flex: 1;
    height: 40px;
    line-height: 40px;
    text-align: center;
}

.box2 {
    width: 440px;
    height: 210px;
    background: #171325ff;
    border: 1px solid #171325ff;
    padding: 15px 10px 0 10px;

    .shu {
        width: 2px;
        height: 15px;
        background-color: #13DCEA;
    }

    .heng {
        margin-top: 15px;
        width: 100%;
        border: 1px solid #ffffff4d;
    }

    .content {
        margin-top: 9px;
        padding-left: 10px;

        img {
            width: 150px;
            height: 142px;
            // margin-left: 40px;
        }
    }
}

.box3 {
    border: 1px solid #3a3a3aff;
    border-radius: 2px;
    padding: 16px 10px;

    .box4 {
        width: 300px;
        height: 156px;
        border: 1.5px solid #171325ff;
        padding: 10px;

        .shu {
            width: 2px;
            height: 10px;
            background-color: #13DCEA;
        }

        .heng {
            margin-top: 5px;
            width: 100%;
            border: 1px solid #ffffff4d;
        }

    }
}



.size18 {
    font-size: 18px;
}

.size14 {
    font-size: 14px;
}

.opc8 {
    opacity: 0.8
}

.picIcon {
    width: 14px;
    height: 14px;
}

.line {
    width: 10px;
    height: 10px;
    background-color: #03b503ff;
    border-radius: 5px;
}

.down {
    width: 10px;
    height: 10px;
    background-color: #29314d;
    border-radius: 5px;
}

.animation {
    -webkit-animation: twinkling 5s infinite ease-in-out;
    animation: twinkling 5s infinite ease-in-out;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

@keyframes twinkling {
    0% {
        transform: scale(1);
        opacity: 0.2;
        filter: alpha(opacity=20);
    }

    50% {
        transform: scale(2);
        opacity: 0.5;
        filter: alpha(opacity=50);
    }

    100% {
        transform: scale(1);
        opacity: 0.2;
        filter: alpha(opacity=20);
    }
}
.blink-glow-factory {
  font-size: 30px;
  color: var(--glow-color, #ffffffff);
  animation: blinkGlow 5s infinite;
}

.dashboard-layout {
    gap: 16px;
    align-items: stretch;
    box-sizing: border-box;
    min-height: calc(92vh - 24px);
}

.dashboard-shell {
    padding: 12px;
}

.dashboard-col {
    min-width: 0;
    height: 100%;
    min-height: 0;
    row-gap: 16px;
}

.dashboard-col > * {
    margin-top: 0 !important;
    flex: 1 1 0;
    min-height: 220px;
}

.dashboard-col-left {
    flex: 1 1 380px;
    max-width: 460px;
    min-height: calc(92vh - 24px);
}

.dashboard-col-left > :first-child {
    flex: 0 0 auto;
    min-height: 0;
}

.dashboard-col-left > :last-child {
    flex: 0.9 1 0;
    min-height: 220px;
}

.dashboard-col-middle {
    flex: 1.15 1 560px;
    min-height: calc(92vh - 24px);
}

.dashboard-col-middle > :first-child {
    flex: 1.15 1 0;
    min-height: 360px;
}

.factory-scope-card {
    min-height: 0 !important;
}

.factory-operation-card {
    min-height: 300px !important;
}

.factory-health-card {
    min-height: 390px !important;
}

.factory-alarm-record-card {
    min-height: 330px !important;
}

.factory-zone-col {
    margin-left: 12px !important;
}

.factory-zone-card {
    min-height: 740px !important;
}

.dashboard-col-left > :last-child,
.dashboard-col-middle > :last-child {
    margin-top: auto !important;
}

.dashboard-layout-alt {
    gap: 16px;
    align-items: flex-start;
    box-sizing: border-box;
}

.dashboard-alt-left {
    flex: 0 0 620px;
    max-width: 680px;
    row-gap: 16px;
}

.dashboard-alt-left > * {
    margin-top: 0 !important;
    flex: 1 1 0;
    min-height: 500px;
}

.dashboard-alt-middle {
    flex: 0 0 450px;
    max-width: 480px;
    row-gap: 16px;
}

.dashboard-alt-middle > * {
    margin-top: 0 !important;
}

.dashboard-alt-right {
    flex: 0 0 380px;
    max-width: 420px;
    min-width: 360px;
}

.zone-radar-row {
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 20px;
}

.zone-radar-item {
    flex: 1 1 220px;
    min-width: 180px;
    max-width: 220px;
}

.zone-radar-chart {
    width: 100%;
    height: 220px;
}

#chartA {
    will-change: filter;
    animation: wheel-breath-condition 3.2s ease-in-out infinite;
}

@keyframes wheel-breath-condition {
    0%,
    100% {
        filter: drop-shadow(0 0 1px rgba(28, 196, 139, 0.14))
            drop-shadow(0 0 2px rgba(206, 224, 8, 0.10));
    }
    50% {
        filter: drop-shadow(0 0 4px rgba(28, 196, 139, 0.30))
            drop-shadow(0 0 4px rgba(206, 224, 8, 0.24))
            drop-shadow(0 0 4px rgba(223, 87, 45, 0.20))
            drop-shadow(0 0 4px rgba(162, 3, 53, 0.18));
    }
}

@media (max-width: 1440px) {
    .dashboard-col-left {
        max-width: 420px;
    }

    .dashboard-alt-left {
        flex-basis: 580px;
        max-width: 640px;
    }

    .dashboard-alt-middle {
        flex-basis: 420px;
        max-width: 460px;
    }

    .dashboard-alt-right {
        flex-basis: 360px;
        max-width: 400px;
    }
}

@media (max-width: 1200px) {
    .dashboard-layout,
    .dashboard-layout-alt {
        flex-wrap: wrap;
    }

    .dashboard-col > *,
    .dashboard-alt-left > * {
        flex: 0 0 auto;
        min-height: auto;
    }

    .dashboard-col-left > :last-child,
    .dashboard-col-middle > :last-child {
        margin-top: 0 !important;
    }

    .dashboard-col-left > :first-child,
    .dashboard-col-left > :last-child {
        min-height: auto;
    }

    .dashboard-col-left,
    .dashboard-col-middle,
    .dashboard-alt-left,
    .dashboard-alt-middle,
    .dashboard-alt-right {
        flex: 1 1 100%;
        max-width: none;
    }

    .zone-radar-row {
        flex-wrap: wrap;
        gap: 12px;
    }

    .zone-radar-item,
    .zone-radar-chart {
        width: min(220px, 100%);
    }
}
</style>